import { buildMiddleware } from 'utilities/state';

const stateKey = 'config';
const storeKey = 'store:config';

const serialize = (appStore, state) => {
    const configState = state[stateKey];

    appStore.set(storeKey, {
        ...configState
    })
};

const deserialize = (appStore, state) => {
    state[stateKey] = appStore.get(storeKey);
};

export default buildMiddleware(serialize, deserialize);